import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Endpoints } from '../../core/api/endpoints';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

    private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}

  getFaqs(): Observable<any[]> {
     return this.http.get<any[]>(
        `${this.baseUrl}/${Endpoints.faq.base}/${Endpoints.faq.get}`
      );
  }
  
}